import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Row, Card, Input } from "reactstrap";
import ReactTable from 'react-table';
import CommentIcon from '../../../../../../../../designUtils/ProjectDashboard/CommentIcon.svg';
import ViewIcon from '../../../../../../../../designUtils/ProjectDashboard/ViewIcon.svg';
import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes, faAngleDown, faAngleUp, faCloudUploadAlt, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import ProjectDeliveriesGraphicsDetails from "./ProjectDeliveriesGraphicsDetails";
import { width } from "@fortawesome/free-solid-svg-icons/faWindowClose";

function ProjectGraphicsDeliveriesDetails(props) {
  const [graphicsStatusFilter, setGraphicsStatusFilter] = useState('Internal Approved');
  const [imageSearchText, setImageSearchText] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [userHasInteracted, setUserHasInteracted] = useState(false);
  const [submissionId, setSubmissionId] = useState(null);

  const statusOptions = [
    { text: 'Internal Approved' },
    { text: 'Approved' },
    { text: 'Partner Revision' },
    { text: 'Moved to Assets Gallery' },
    { text: 'All' }
  ];

  useEffect(() => {
    if (props.submissionData && props.submissionData.id && props.submissionData.id !== submissionId) {
      setUserHasInteracted(false);
      setGraphicsStatusFilter('Internal Approved');
      setSubmissionId(props.submissionData.id);
    }
  }, [props.submissionData && props.submissionData.id, submissionId]);

  useEffect(() => {
    if (props.graphicsAssets && props.graphicsAssets.length > 0 && !userHasInteracted) {
      const hasInternalApproved = props.graphicsAssets.some(
        asset => asset.statusText === 'Internal Approved'
      );
      
      if (!hasInternalApproved && graphicsStatusFilter === 'Internal Approved') {
        setGraphicsStatusFilter('All');
      }
    }
  }, [props.graphicsAssets, graphicsStatusFilter, userHasInteracted]);

  

  const filteredImages = props.graphicsAssets && props.graphicsAssets.filter(asset => {
    const matchesSearch =
      (asset.assetName && asset.assetName.toLowerCase().includes(imageSearchText.toLowerCase())) ||
      String(asset.assetId || '').includes(imageSearchText);

    const matchesStatus =
      graphicsStatusFilter === 'All' || asset.statusText === graphicsStatusFilter;

    return matchesSearch && matchesStatus;
  });

useEffect(() => {
  if (
    graphicsStatusFilter === 'All' &&
    filteredImages &&
    filteredImages.length > 0
  ) {
    const firstImage = filteredImages[0];
    if (typeof props.setSelectedImage === 'function') {
      props.setSelectedImage(firstImage);
    }
    if (typeof props.setSelectedStatus === 'function') {
      props.setSelectedStatus(firstImage.status || firstImage.statusText || 'new');
    }
  }
}, [graphicsStatusFilter]); 
  return (
    <>
    <Row className='ml-0'>
      <Col md={8} className="d-flex flex-wrap align-items-center mt-1">
        {statusOptions.map((item, index) => {
          const statusCount = item.text === 'All' 
          ? props.graphicsTotal
          : (props.graphicsStatusCount[item.text] || 0);
          return (
          <div key={index} className="status-radio-wrapper">
            <label
              htmlFor={`graphics-${item.text.replace(/\s+/g, '-')}`}
              className={`status-radio-label ${item.text.replace(/\s+/g, '-')} ${graphicsStatusFilter === item.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                id={`graphics-${item.text.replace(/\s+/g, '-')}`}
                name="graphicsStatusFilter"
                value={item.text}
                checked={graphicsStatusFilter === item.text}
                onChange={() => {
                  setGraphicsStatusFilter(item.text);
                  setUserHasInteracted(true);
                  // setSelectedImageAsset(null);
                }}
              />
              <span className="ml-2">{item.text}</span>
              <b
            className="assetsStatusCount"
            style={{
              minWidth: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              minHeight: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              padding: `4px ${Math.max(6, (statusCount || 0).toString().length * 3)}px`
            }}
          >
            {statusCount || 0}
          </b>
            </label>
          </div>
          )
})}
        
       
      </Col>
      <Col md={4} className='mt-2'>

        <Input
          type="text"
          placeholder="Search"
          className="w-100"
          value={imageSearchText}
          onChange={(e) => setImageSearchText(e.target.value)}
        />
      </Col>
      <Col md={12}>
      {graphicsStatusFilter === 'Internal Approved' && filteredImages && filteredImages.length > 0 && (
        <div className="mt-2">
          <span className="client-note">Requesting approval—please check and approve the submitted assets.</span>
        </div>
      )}
      </Col>
      </Row>
     

      <Row>
        {filteredImages && filteredImages.length > 0 ? (
        <ProjectDeliveriesGraphicsDetails
            setAllAssetsList={props.setAllAssetsList}
            selectedImage={props.selectedImage}
            setSelectedImage={props.setSelectedImage}
            selectedStatus={selectedStatus}
            submissionData={props.submissionData}
            setSelectedStatus={setSelectedStatus}
            setGraphicsStatusCount={props.setGraphicsStatusCount}
            setGraphicsTotal={props.setGraphicsTotal}
            setDocumentStatusCount={props.setDocumentStatusCount}
            setDocumentTotal={props.setDocumentTotal}
            // onClose={() => props.setSelectedASIN(null)}
            setSubmissionList={props.setSubmissionList}
            setAllOriginalFiles={props.setAllOriginalFiles}
            allOriginalFiles={props.allOriginalFiles}
            file={filteredImages}
            action={props.action}
            flag={props.flag}
            graphicsAssets={props.graphicsAssets}
            loggedInUser={props.loggedInUser}
            projectPermissions={props.projectPermissions}
            selectedProjectData={props.selectedProjectData}
            // selectedSubCategories={props.selectedSubCategories}
            setAssetList={props.setAssetList}
            // subCategoryId={props.selectedSubCategories.id}
            // assetCategory={props.selectedSubCategories.assetCategory}
            // assetIdentifier={props.selectedASIN}
            // asinList={props.selectedASIN}
            // statusTexts={statusTexts}
          />
        ) : (
          <Col md={12}>
          <div className="no-images-wrapper" style={{ position: "relative", minHeight: "200px" }}>
            {/* Message in Center */}
            <Row className="justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <Col md={12} className="text-center mt-5">
                <div className="no-images-container" style={{ padding: "50px 20px" }}>
                  <h4 style={{ color: "#666", marginBottom: "10px" }}>No Graphics Available</h4>
                </div>
              </Col>
            </Row>
          </div>
          </Col>
        )}
      </Row>
      
    </>
  )
}
function ProjectDocumentDeliveriesDetails(props) {
  const [downloading, setdownloading] = useState(false);
  const [documentStatusFilter, setDocumentStatusFilter] = useState('Internal Approved');
  const [documentSearchText, setDocumentSearchText] = useState('');
  const [userHasInteracted, setUserHasInteracted] = useState(false);
  const [submissionId, setSubmissionId] = useState(null);
  
const statusOptions = [
    { text: 'Internal Approved' },
    { text: 'Approved' },
    { text: 'Re-Work' },
    { text: 'Moved to Assets Gallery' },
    { text: 'All' }
  ];

  // Reset when submission changes
  useEffect(() => {
    if (props.submissionData && props.submissionData.id && props.submissionData.id !== submissionId) {
      setUserHasInteracted(false);
      setDocumentStatusFilter('Internal Approved');
      setSubmissionId(props.submissionData.id);
    }
  }, [props.submissionData && props.submissionData.id, submissionId]);

  useEffect(() => {
    if (props.documentAssets && props.documentAssets.length > 0 && !userHasInteracted) {
      const hasInternalApproved = props.documentAssets.some(
        doc => doc.statusText === 'Internal Approved'
      );
      
      if (!hasInternalApproved && documentStatusFilter === 'Internal Approved') {
        setDocumentStatusFilter('All');
      }
    }
  }, [props.documentAssets, documentStatusFilter, userHasInteracted]);
  
  const filteredDocuments = props.documentAssets && props.documentAssets.filter(asset => {
    const matchesSearch =
      (asset.assetName && asset.assetName.toLowerCase().includes(documentSearchText.toLowerCase())) ||
      String(asset.assetId || '').includes(documentSearchText) ||
      (asset.statusText && asset.statusText.toLowerCase().includes(documentSearchText.toLowerCase()));
  
    const matchesStatus =
      documentStatusFilter === 'All' || asset.statusText === documentStatusFilter;
  
    return matchesSearch && matchesStatus;
  });


  const handleDownloadImage = async (url, fileObject) => {
    try {
      setdownloading(fileObject.id);
      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });

      if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.id}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download =  fileObject.assetName|| 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
      setdownloading(false);
    } catch (error) {
      console.error('Failed to download files:', error);
      setdownloading(false);
    }
  };

  const columns = [
    {
      Header: "Name",
      accessor: "assetName",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-start w-100">
          <p className=" m-0 cursor-pointer" onClick={() => props.handleImgdetails(cellInfo.original)} >{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Status",
      width:120,
      accessor: "statusText",
      width: 200,        
      minWidth: 200,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-between w-100 ">
          <p title={cellInfo.value} className="m-0 comment-paragraph text-center">
            {cellInfo.value}
          </p>
        </div>
      ),
    },
    {
      Header: "Action",
      width:65,
      accessor: "fileType",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <img
            src={DownloadIcon}
            alt="Download"
            height={20}
            width={20}
            //   style={{ cursor: 'pointer', marginLeft: isPDF ? '10px' : '0px' }}
            title="Download"
            className={
              downloading && downloading === cellInfo.original.assetId
                ? "button-img-background-download-inprogress"
                : ""
            }
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (downloading !== cellInfo.original.assetId) {
                //   setSelectedFileObject(file);
                setdownloading(cellInfo.original.assetId);
                handleDownloadImage(cellInfo.original.filePath, cellInfo.original);
              }
            }}
          />
        </div>
      )
    }]
  return (
    <>
    <Row>
      <Col md={8} className="d-flex flex-wrap align-items-center mt-1">
        {statusOptions.map((item, index) => {
           const statusCount = item.text === 'All' 
           ? props.documentTotal
           : (props.documentStatusCount[item.text] || 0);
           return (
          <div key={index} className="status-radio-wrapper">
            <label
              htmlFor={`document-${item.text.replace(/\s+/g, '-')}`}
              className={`status-radio-label ${item.text.replace(/\s+/g, '-')} ${documentStatusFilter === item.text ? 'selected' : ''}`}
            >
              <input
                type="radio"
                id={`document-${item.text.replace(/\s+/g, '-')}`}
                name="documentStatusFilter"
                value={item.text}
                checked={documentStatusFilter === item.text}
                onChange={() => {
                  setDocumentStatusFilter(item.text);
                  setUserHasInteracted(true);
                  //  setSelectedImageAsset(null);
                }}
              />
              <span className="ml-2">{item.text}</span>
              <b
            className="assetsStatusCount"
            style={{
              minWidth: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              minHeight: `${Math.max(16, (statusCount || 0).toString().length * 10)}px`,
              padding: `4px ${Math.max(6, (statusCount || 0).toString().length * 3)}px`
            }}
          >
            {statusCount || 0}
          </b>
            </label>
          </div>
           )
})}
      </Col>
      <Col cd={4} className='mt-2'>
        <Input
          type="text"
          placeholder="Search Text"
          className="w-100"
          value={documentSearchText}
          onChange={(e) => setDocumentSearchText(e.target.value)}
        />
      </Col>
      <Col md={12}>
        {documentStatusFilter === 'Internal Approved' && filteredDocuments && filteredDocuments.length > 0 && (
        <div className="mt-2">
          <span className="client-note">Requesting approval—please check and approve the submitted assets.</span>
        </div>
      )}
      </Col>
      </Row>
      <Row>
        <Col md={12}>
      <ReactTable
        data={filteredDocuments || []}
        columns={columns}
        className="-fixed -highlight -striped mt-4"
        getTheadProps={() => {
          return {
            style: {
              overflowY: "hidden",
              background: "#B1FA63",
              color: "#243837",
            },
          };
        }}
        defaultPageSize={5}
        noDataText={"No Data Found."}
      /></Col>
</Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,

});
export default connect(mapStateToProps)(ProjectDocumentDeliveriesDetails);
export { ProjectGraphicsDeliveriesDetails }